import classNames from 'classnames';

const SingleSelect = ({ item, index, disabled, HandleResponse }) => {
    return (
        <ul className="radio-list">
            {item.options.map((it: any, buttonIndex: number) => {
                return (
                    // <button
                    //    className={classNames("btn btn--outline", { 'btn--disable': index !== convo.length - 1 })}
                    //    key={buttonIndex}
                    //    disabled={index !== convo.length - 1}
                    //    onClick={() => customButtonClicked(it)}
                    // >
                    //    {it}
                    // </button>
                    <li key={`key-checkbox-option-${index}-${buttonIndex}`}>
                        {item?.asButton && (
                            <button
                                className={classNames('btn btn--outline btn--radio', {
                                    'btn--disable': disabled
                                })}
                                key={buttonIndex}
                                disabled={disabled}
                                onClick={() =>
                                    !disabled && HandleResponse([it], buttonIndex, item, false, false, item.question_id)
                                }>
                                {it?.label}
                            </button>
                        )}
                        {!item?.asButton && (
                            <>
                                <input
                                    disabled={disabled}
                                    type="radio"
                                    id={`id-${buttonIndex}-${index}`}
                                    name={`question-${index}`}
                                    value={it?.label}
                                    readOnly
                                    checked={
                                        item.answer && item.answer.length > 0 ? it?.label === item.answer[0] : false
                                    }
                                    onClick={() => !disabled && HandleResponse([it], buttonIndex, item)}
                                    className="rating__field"
                                />
                                <label htmlFor={`id-${buttonIndex}-${index}`} className="rating__label">
                                    <span className="placeholder">{it?.label}</span>
                                </label>
                            </>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default SingleSelect;
